module.exports = __webpack_public_path__ + "img/loader.a117b60e.gif";